/**
 * A segmented row of quick-select buttons, the same look as Nutrition's
 * `np-bwtrend__ranges`, with the active option's text in the brand gradient.
 * `tabs` makes it a tablist.
 */
const QuickToggle = ({ options, value, onSelect, label, tabs = false }) => {
  if (tabs) {
    return (
      <div className="door-quick" role="tablist" aria-label={label}>
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={value === option.value}
            onClick={() => onSelect(option.value)}
          >
            <span>{option.label}</span>
          </button>
        ))}
      </div>
    );
  }

  return (
    <fieldset className="door-quick" aria-label={label}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          aria-pressed={value === option.value}
          onClick={() => onSelect(option.value)}
        >
          <span>{option.label}</span>
        </button>
      ))}
    </fieldset>
  );
};

export default QuickToggle;
